import { render, staticRenderFns } from "./QHuploadImg.vue?vue&type=template&id=6884e0b6"
import script from "./QHuploadImg.vue?vue&type=script&lang=js"
export * from "./QHuploadImg.vue?vue&type=script&lang=js"
import style0 from "./QHuploadImg.vue?vue&type=style&index=0&id=6884e0b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports